import { Label } from '@ffx/common';

export const replaceLabel = (labels: Label[], labelToReplace: Label, label: Label): Label[] => {
    const index = labels.findIndex((item) => item.name === labelToReplace.name);
    if (index !== -1) {
        labels[index] = { name: label.name, icon: label.icon };
    }
    return labels;
};
